import { ParamListBase } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import React from 'react'
import {
  Dropdown,
  DropdownFooterOptionsProps,
  DropdownItemComponentProps,
  DropdownSection,
} from '../components/dropdown'

export function showHeaderTitleDropdown<
  ParamList extends ParamListBase,
  RouteName extends keyof ParamList
>(
  navigation: StackNavigationProp<ParamList, RouteName>,
  sections: DropdownSection[],
  selectedId: any,
  onSelect: (id: any) => void,
  dropdownFooterOptionsProps?: DropdownFooterOptionsProps,
  activeFilterNames?: () => string,
  showCustomFilters?: boolean,
  itemComponent?: (props: DropdownItemComponentProps) => React.JSX.Element
) {
  navigation.setOptions({
    headerTitle: props => (
      <Dropdown
        sections={sections}
        selectedId={selectedId}
        onSelect={onSelect}
        title={props.children}
        activeFilterNames={activeFilterNames}
        showCustomFilters={showCustomFilters}
        dropdownFooterOptionsProps={dropdownFooterOptionsProps}
        ItemComponent={itemComponent}
      />
    ),
  })
}
